'use client'
import { TableColumnDataProps, TableHeadCustom, TableNoData, useTable } from '@/components'
import { TableBody } from '@mui/material'
import Table from '@mui/material/Table'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
type Props<T> = {
  columns: TableColumnDataProps<T>[]
  data: T[]
}

export const PrimaryTable = <T,>({ columns, data }: Props<T>) => {
  const table = useTable()
  return (
    <Table size={table.dense ? 'small' : 'medium'}>
      <TableHeadCustom headCells={columns} numSelected={table.selected.length} onSort={table.onSort} />

      <TableBody
        sx={{
          '&.MuiTableBody-root': {
            border: '1px solid #e0e0e0',
          },
        }}
      >
        {data?.map((row, index) => {
          return (
            <TableRow key={index}>
              {columns?.map((column) => {
                return (
                  <TableCell key={column.id} align={column.align}>
                    {column?.render && column?.render(row)}
                  </TableCell>
                )
              })}
            </TableRow>
          )
        })}

        <TableNoData notFound={!data?.length} />
      </TableBody>
    </Table>
  )
}
